<template>
  <AppLayout>
    <div class="task-page" @click="closeUserMenu">
      <!-- 右上角：个人中心入口 + 下拉 -->
      <div class="user-entry" @click.stop>

        <div class="user-menu-head" @click="toggleUserMenu">
          <div class="head-left">
            <img src="@/assets/账号 1@2x.png" alt="" />

            <div class="head-title">账号</div>
          </div>

          <button class="head-btn" type="button">
            个人中心
            <img src="@/assets/Icon／Outline／cheveron-right(1).png" class="head-btn-icon1" alt="" />

          </button>
        </div>

        <transition name="fade-pop">
          <div v-if="userMenuOpen" class="user-menu" role="menu" aria-label="个人中心下拉">


            <div class="user-menu-body" @click="goUserCenter">
              <div class="user-row">
                <div class="user-avatar">
                  <img
                    src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=120&q=80"
                    alt="" />
                </div>

                <div class="user-info">
                  <div class="user-name">酱豆</div>
                  <div class="user-phone">手机号：15012345678</div>
                </div>

                <div class="user-verify">已认证</div>
              </div>

              <div class="divider" />

              <button class="menu-item" type="button" @click="goMyPublish">
                <span class="mi-left">

                  <img src="@/assets/订单中心 1@2x.png" class="head-btn-icon" alt="" />
                  <span class="mi-text">我的发布</span>
                </span>

                <img src="@/assets/Icon／Outline／cheveron-right(1).png" class="head-btn-icon1" alt="" />
              </button>

              <button class="menu-item" type="button" @click="goOrders">
                <span class="mi-left">
                
                  <img src="@/assets/订单中心 1@2x (1).png" class="head-btn-icon" alt="" />
                  <span class="mi-text">订单中心</span>
                </span>
              
                <img src="@/assets/Icon／Outline／cheveron-right(1).png" class="head-btn-icon1" alt="" />
              </button>
            </div>
          </div>
        </transition>
      </div>

      <div class="grid">
        <el-card v-for="item in list" :key="item.id" class="talent-card" shadow="never" body-style="padding: 0">
          <div class="talent-inner" @click="jop(item)">
            <!-- 顶部：左信息 + 右头像 -->
            <div class="talent-top">
              <div class="talent-left">
                <div class="talent-name">{{ item.name || item.title || '职位' }}</div>
                <!-- 技能标签 -->
                <div class="talent-tags">
                  <span v-for="t in item.tags" :key="t" class="talent-tag">
                    {{ t }}
                  </span>
                </div>

                <!-- 评分 -->
                <div class="talent-rating">
                  <span class="talent-rating-label">评分：</span>
                  <img src="../assets/Frame 2931@2x.png" alt="" class="talent-star" />

                  <span class="talent-score">{{ item.rating ?? '4.8' }}</span>
                </div>

                <!-- 价格/接单数 -->
                <div class="talent-metas">
                  <div class="talent-meta">
                    <img class="talent-meta-icon" src="../assets/icon-money 1@2x.png" alt="" />
                    <div class="talent-meta-text">
                      <div class="talent-meta-main">¥ {{ item.price ?? item.budget ?? 1000 }}/时</div>
                      <div class="talent-meta-sub">项目报价</div>
                    </div>
                  </div>

                  <div class="talent-meta">
                    <img class="talent-meta-icon" src="../assets/接单数据 1@2x.png" alt="" />
                    <div class="talent-meta-text">
                      <div class="talent-meta-main">{{ item.orders ?? 186 }}</div>
                      <div class="talent-meta-sub">接单数</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="talent-right1">
                <div class="talent-avatar">
                  <img
                    src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=200&q=80"
                    alt="" />
                </div>
                <span>名称名称</span>
              </div>
            </div>

            <!-- 底部：按钮 + 查看详情 -->
            <div class="talent-bottom">
              <el-button class="talent-cta" type="success" @click.stop="openQuote(item)">
                立即联系
                <img class="arrow" src="../assets/next.png" alt="" />
              </el-button>

              <button class="talent-detail" type="button" @click.stop="jop(item)">
                查看详情
                <img style="width: 16px; height: 16px" src="../assets/Icon／Outline／cheveron-right@2x.png" alt="" />
              </button>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 报价弹窗 -->
      <el-dialog v-model="quoteOpen" width="640px" align-center :teleported="false" :show-close="false"
        :close-on-click-modal="true" :close-on-press-escape="true" class="quote-dialog">
        <div class="quote-body">
          <div class="quote-title">立即报价</div>

          <el-form ref="quoteFormRef" class="quote-form" :model="quoteForm" :rules="quoteRules" label-position="top"
            status-icon :hide-required-asterisk="false" @submit.prevent>
            <el-form-item label="金额" prop="price" required>
              <el-input v-model.trim="quoteForm.price" placeholder="请输入" />
            </el-form-item>

            <el-form-item label="预计完成时间" prop="eta" required>
              <el-date-picker v-model="quoteForm.eta" type="date" placeholder="请选择" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" style="width: 100%" />
            </el-form-item>

            <el-button class="quote-submit" type="success" :loading="submitting" @click="submitQuote">
              提交
            </el-button>
          </el-form>
        </div>
      </el-dialog>

      <!-- 报价成功弹窗 -->
      <el-dialog v-model="successOpen" width="420px" align-center :teleported="false" modal :lock-scroll="true"
        :show-close="false" :close-on-click-modal="true" :close-on-press-escape="true" class="success-dialog">
        <div class="success-body">
          <img class="success-icon" src="../assets/Frame 9800.png" alt="" />
          <div class="success-title">报价成功</div>
          <div class="success-desc">报价成功，等待甲方回复</div>

          <div class="success-actions">
            <el-button type="success" class="success-cta" @click="continueBrowse">继续浏览</el-button>
            <el-button type="success" link @click="goHome">返回首页</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </AppLayout>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const router = useRouter()

const list = ref(
  Array.from({ length: 8 }).map((_, i) => ({
    id: i + 1,
    title: '姓名',
    budget: 1000,
    tags: ['技能1', '技能2', '技能2', '技能2', '技能2'],
    rating: 4.8,
    orders: 186
  }))
)

/* ===== 右上角个人中心下拉 ===== */
const userMenuOpen = ref(false)

function toggleUserMenu() {
  userMenuOpen.value = !userMenuOpen.value
}
function closeUserMenu() {
  userMenuOpen.value = false
}

function goUserCenter() {
  userMenuOpen.value = false
  router.push('/profile') // 按你实际路由改
}
function goMyPublish() {
  userMenuOpen.value = false
  router.push('/profile') // 按你实际路由改
}
function goOrders() {
  userMenuOpen.value = false
  router.push('/profile') // 按你实际路由改
}

/* ===== 报价弹窗逻辑 ===== */
const quoteOpen = ref(false)
const successOpen = ref(false)
const submitting = ref(false)
const currentTask = ref(null)

const quoteFormRef = ref(null)
const quoteForm = reactive({
  price: '',
  eta: '' // YYYY-MM-DD
})

function validateMoney(_rule, v, cb) {
  const val = String(v ?? '').trim()
  if (!val) return cb(new Error('请输入金额'))
  if (!/^\d+(\.\d{1,2})?$/.test(val)) return cb(new Error('金额格式不正确（最多两位小数）'))
  const n = Number(val)
  if (!Number.isFinite(n) || n <= 0) return cb(new Error('金额必须大于 0'))
  cb()
}

function validateEta(_rule, v, cb) {
  const val = String(v ?? '').trim()
  if (!val) return cb(new Error('请选择预计完成时间'))
  cb()
}

const quoteRules = reactive({
  price: [
    { required: true, message: '请输入金额', trigger: 'blur' },
    { validator: validateMoney, trigger: ['blur', 'change'] }
  ],
  eta: [
    { required: true, message: '请选择预计完成时间', trigger: 'change' },
    { validator: validateEta, trigger: 'change' }
  ]
})

function openQuote(task) {
  currentTask.value = task
  quoteForm.price = ''
  quoteForm.eta = ''
  quoteOpen.value = true
}

function jop() {
  router.push('/talentPoolDetail')
}

async function submitQuote() {
  if (!quoteFormRef.value) return
  try {
    await quoteFormRef.value.validate()
    submitting.value = true
    await new Promise((r) => setTimeout(r, 600))
    quoteOpen.value = false
    successOpen.value = true
  } catch {
    // 校验不通过
  } finally {
    submitting.value = false
  }
}

function continueBrowse() {
  successOpen.value = false
}

function goHome() {
  successOpen.value = false
  router.push('/home')
}
</script>

<style lang="scss" scoped>
:deep .el-date-editor {
  height: 52px !important;
}

.task-page {
  min-height: calc(100vh - 64px);
  padding: 0px 240px 64px;
  background-image: url('../assets/未标题-1 1.png');

  @media (max-width: 1400px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  @media (max-width: 960px) {
    padding: 18px 16px 48px;
  }
}

/* =========================
   右上角个人中心（1:1还原）
   ========================= */
.user-entry {
  display: flex;
  justify-content: right;
  z-index: 50;
}

/* 右上角触发（邮箱+小圆点，接近你UI右上角账号区域） */
.user-chip {
  height: 32px;
  padding: 0 10px 0 12px;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.user-chip-text {
  font-size: 12px;
  color: #333333;
  line-height: 1;
}

.user-chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4caf50;
}

/* 下拉卡片 */
.user-menu {
  width: 399px;
  /* UI标注 399px */
  height: 200px;
  /* UI标注 248px */
  position: absolute;
  top: 145px;
  z-index: 999;
  backdrop-filter: blur(12px);   
  // border-radius: 8px;
  overflow: hidden;
  background: #ffffff80;
  // border: 1px solid rgba(0, 0, 0, 0.08);
  // box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);

  @media (max-width: 960px) {
    width: min(399px, calc(100vw - 32px));
  }
}

/* 头部浅绿色条 */
.user-menu-head {
  width: 399px;
  height: 54px;
  padding: 0 16px;
  background: #E5FFE6;
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.head-left {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  img {
    width: 20px;
    height: 20px;
  }
}

.head-title {
  font-size: 16px;
  font-weight: 600;
  color: #2b2f33;
}

/* 左侧“账号”图标（用CSS画，避免你缺图片） */
.head-icon {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 2px dashed rgba(76, 175, 80, 0.65);
  position: relative;
}

.head-icon::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 45%;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.65);
  transform: translate(-50%, -60%);
}

.head-icon::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 62%;
  width: 14px;
  height: 8px;
  border-radius: 8px 8px 4px 4px;
  background: rgba(76, 175, 80, 0.65);
  transform: translate(-50%, 0);
}

/* 右侧“个人中心”按钮 */
.head-btn {
  width: 90px;
  height: 28px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #4CAF50;
  font-weight: 500;
  font-size: 14px;
  color: #4CAF50;
  background: transparent;

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.head-btn-icon1 {
  width: 16px;
  height: 16px;
}

.head-btn-icon {
  width: 24px;
  height: 24px;
}



/* body */
.user-menu-body {
  padding: 24px;
}

.user-row {
  display: grid;
  grid-template-columns: 24px 1fr auto;
  gap: 12px;
  // align-items: center;
  padding: 0px 0 10px;
}

.user-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  background: #f3f3f3;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #2b2f33;
  line-height: 1.1;
  margin-bottom: 6px;
}

.user-phone {
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.1;
}

/* 右侧蓝色“已认证” */
.user-verify {
  height: 25px;
  min-width: 86px;
  padding: 0 14px;
  background: #4791FF;
  border-radius: 4px 4px 4px 4px;


  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 8px 0;
}

/* 菜单项 */
.menu-item {
  width: 100%;
  height: 47px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 2px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-item:hover {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
}

.mi-left {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.mi-text {
  font-size: 16px;
  font-weight: 600;
  color: #2b2f33;
}

/* 左侧图标（虚线框风格） */
.mi-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 2px dashed rgba(76, 175, 80, 0.65);
  position: relative;
}

.mi-icon--pub::after {
  content: '';
  position: absolute;
  left: 7px;
  top: 7px;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  border: 2px solid rgba(76, 175, 80, 0.65);
}

.mi-icon--order::after {
  content: '';
  position: absolute;
  left: 7px;
  top: 6px;
  width: 14px;
  height: 16px;
  border-radius: 2px;
  border: 2px solid rgba(76, 175, 80, 0.65);
}

/* 右侧箭头（虚线框+箭头感） */
.mi-arrow {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px dashed rgba(0, 0, 0, 0.25);
  position: relative;
  flex: 0 0 auto;
}

.mi-arrow::after {
  content: '';
  position: absolute;
  left: 8px;
  top: 6px;
  width: 6px;
  height: 6px;
  border-right: 2px solid rgba(0, 0, 0, 0.35);
  border-bottom: 2px solid rgba(0, 0, 0, 0.35);
  transform: rotate(-45deg);
}

/* 动画 */
.fade-pop-enter-active,
.fade-pop-leave-active {
  transition: 0.16s ease;
}

.fade-pop-enter-from,
.fade-pop-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* =========================
   你原来的列表样式（保持不动）
   ========================= */
.grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
}

.talent-card {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.1), -4px -4px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid #e9e9e9;

  :deep(.el-card__body) {
    padding: 0 !important;
  }
}

.talent-inner {
  padding: 28px;

}

.talent-top {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  min-width: 0;
}

.talent-left {
  min-width: 0;
}

.talent-name {
  font-weight: 600;
  font-size: 18px;
  color: #111111;
  margin-bottom: 10px;
}

.talent-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.talent-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 10px;
  border-radius: 4px;
  background: #f6f6f6;
  font-size: 12px;
  color: #638264;
  line-height: 20px;
}

.talent-rating {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 34px;
  font-size: 12px;
  color: #8c8c8c;
}

.talent-star {
  width: 16px;
  height: 16px;
}

.talent-score {
  font-weight: 600;
  font-size: 12px;
  color: #1f1f1f;
}

.talent-metas {
  display: flex;
  align-items: flex-start;
  gap: 26px;
}

.talent-meta {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.talent-meta-icon {
  width: 24px;
  height: 24px;
  margin-top: 2px;
}

.talent-meta-main {
  font-size: 14px;
  color: #111111;
  line-height: 1.2;
}

.talent-meta-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #a5a5a5;
}

.talent-right1 {
  flex: 0 0 auto;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  text-align: center;
}

.talent-avatar {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 8px;
}

.talent-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.talent-bottom {
  margin-top: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

:deep(.talent-cta.el-button) {
  width: 163px;
  height: 48px;
  background: #4caf50;
  border-radius: 6px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 14px;

  .arrow {
    width: 16px;
    height: 16px;
    margin-left: 6px;
  }
}

.talent-detail {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #333333;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 0;
}

.talent-detail:hover {
  text-decoration: underline;
}

/* ===== 你原来的弹窗样式保持不动 ===== */
:deep(.quote-dialog .el-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.quote-dialog .el-dialog__header) {
  display: none;
}

:deep(.quote-dialog .el-dialog__body) {
  padding: 0;
}

.quote-body {
  padding: 32px 63px;
}

.quote-title {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  margin: 0px 0 18px;
}

:deep(.quote-dialog .quote-form) {
  .el-form-item {
    margin-bottom: 18px;
  }

  .el-form-item__label {
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    padding-bottom: 6px;
  }

  .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: static !important;
  }

  .el-form-item__error,
  .el-form-item__error--inline {
    position: static !important;
    display: block !important;
    width: 100%;
    margin-top: 6px;
    padding: 0;
    line-height: 1.2;
    white-space: normal;
    z-index: auto !important;
    transform: none !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
  }

  .el-input__wrapper,
  .el-date-editor .el-input__wrapper {
    height: 48px;
    border-radius: 8px;
    box-sizing: border-box;
  }
}

:deep(.quote-submit.el-button) {
  height: 48px;
  background: #4caf50;
  border-radius: 4px;
  width: 100%;
  margin-top: 36px;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

:deep(.success-dialog .el-dialog) {
  border-radius: 8px;
  overflow: hidden;
}

:deep(.success-dialog .el-dialog__header) {
  display: none;
}

:deep(.success-dialog .el-dialog__body) {
  padding: 32px 63px;
}

.success-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.success-icon {
  margin: 0px 0 28px;
  width: 100px;
  height: 100px;
}

.success-title {
  font-weight: 400;
  font-size: 20px;
  color: #2e323e;
  margin-bottom: 6px;
}

.success-desc {
  font-weight: 400;
  font-size: 16px;
  color: #9899a2;
  margin-bottom: 48px;
}

.success-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
}

:deep(.success-cta.el-button) {
  width: 260px;
  height: 41px;
  background: linear-gradient(39deg, #4caf50 0%, #91df35 100%);
  box-shadow: 2px 2px 4px 0px rgba(24, 144, 255, 0.1);
  border-radius: 200px;
}
</style>